<p-toast position="top-center" key="config"></p-toast>
<div class="card p-mt-5">
    <form [formGroup]="form" (ngSubmit)="complete()">
        <p-accordion>
            <p-accordionTab header="Configuracion sets de Bolillas">
                <app-model-range-gna-edit [modelRangeGNAForm]="form.get('configSets')" [type]="'form'" [nameMachine]="'Rango de numeros a generar'" [isAmount]="false"></app-model-range-gna-edit>
            </p-accordionTab>
            <p-accordionTab header="Adicionales">
                <div class="col"> 
                    <label for="urlGna" class="labelForm">Url del GNA</label>
                    <div class="p-inputgroup">
                        <input id="float-input" type="text" placeholder="http://localhost:3001" pInputText formControlName="urlGna">
                    </div>
                </div>
                <div class="col p-mt-3"> 
                    <label for="status" class="labelForm">Estado</label>
                    <div class="p-inputgroup">
                        <p-dropdown [options]="statusOpt" formControlName="status" placeholder="Selecciona un estado" optionLabel="name" optionValue="value" [showClear]="true" ></p-dropdown>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion> 
        <div class="p-mt-5">
            <button *ngIf="type === 'edit'" type="submit" pButton label="Editar configuración de presorteo" [disabled]="!valid"></button>
            <button *ngIf="type === 'create'" type="submit" pButton label="Crear configuracion de presorteo" [disabled]="!valid"></button>
        </div>
    </form>
</div>